import React from "react";

import UserDetail from "components/branches/branchUserDetail/BranchUserDetail";

import "./branchUserDetail.scss";
const BranchUserDetail = () => {
  return (
    <>
      <UserDetail />
    </>
  );
};

export default BranchUserDetail;
